module.exports = __webpack_public_path__ + "vue-app/img/cross-sell-hebergement-printemps.ee2b7615.jpg";